export const DRAG_AND_DROP_TEXT = 'Drag & Drop Here to Upload';
export const BROWSE_TO_UPLOAD_TEXT = 'Browse to Select Your File';
